import { CATEGORY_BOX_DESKTOP_LARGE_WIDTH, CATEGORY_BOX_DESKTOP_MEDIUM_WIDTH, CATEGORY_BOX_DESKTOP_WIDTH, CATEGORY_BOX_IMAGE_DESKTOP_HEIGHT, CATEGORY_BOX_IMAGE_DESKTOP_LARGE_HEIGHT, CATEGORY_BOX_IMAGE_DESKTOP_MEDIUM_HEIGHT, CATEGORY_BOX_IMAGE_MOBILE_HEIGHT, CATEGORY_BOX_IMAGE_MOBILE_LARGE_HEIGHT, CATEGORY_BOX_IMAGE_MOBILE_MEDIUM_HEIGHT, CATEGORY_BOX_MOBILE_LARGE_WIDTH, CATEGORY_BOX_MOBILE_MEDIUM_WIDTH, CATEGORY_BOX_MOBILE_WIDTH } from './constants';
import { CategoryBoxSize } from './types';
export const getCategoryBoxWidth = ({
  size
}) => {
  switch (size) {
    case CategoryBoxSize.MEDIUM:
      return {
        desktop: CATEGORY_BOX_DESKTOP_MEDIUM_WIDTH,
        mobile: CATEGORY_BOX_MOBILE_MEDIUM_WIDTH
      };
    case CategoryBoxSize.LARGE:
      return {
        desktop: CATEGORY_BOX_DESKTOP_LARGE_WIDTH,
        mobile: CATEGORY_BOX_MOBILE_LARGE_WIDTH
      };
    default:
      return {
        desktop: CATEGORY_BOX_DESKTOP_WIDTH,
        mobile: CATEGORY_BOX_MOBILE_WIDTH
      };
  }
};
export const getCategoryBoxImageHeight = ({
  size
}) => {
  switch (size) {
    case CategoryBoxSize.MEDIUM:
      return {
        desktop: CATEGORY_BOX_IMAGE_DESKTOP_MEDIUM_HEIGHT,
        mobile: CATEGORY_BOX_IMAGE_MOBILE_MEDIUM_HEIGHT
      };
    case CategoryBoxSize.LARGE:
      return {
        desktop: CATEGORY_BOX_IMAGE_DESKTOP_LARGE_HEIGHT,
        mobile: CATEGORY_BOX_IMAGE_MOBILE_LARGE_HEIGHT
      };
    default:
      return {
        desktop: CATEGORY_BOX_IMAGE_DESKTOP_HEIGHT,
        mobile: CATEGORY_BOX_IMAGE_MOBILE_HEIGHT
      };
  }
};
//# sourceMappingURL=utils.js.map